import { syncTaskFactory } from '../../syncTask';
import { splitChangesFetcherFactory } from '../fetchers/splitChangesFetcher';
import { splitChangesUpdaterFactory } from '../updaters/splitChangesUpdater';
/**
 * Creates a sync task that periodically executes a `splitChangesUpdater` task
 */
export function splitsSyncTaskFactory(fetchSplitChanges, storage, readiness, settings, isClientSide) {
    return syncTaskFactory(settings.log, splitChangesUpdaterFactory(settings.log, splitChangesFetcherFactory(fetchSplitChanges), storage.splits, storage.segments, readiness.splits, settings.startup.requestTimeoutBeforeReady, settings.startup.retriesOnFailureBeforeReady, isClientSide), settings.scheduler.featuresRefreshRate, 'splitChangesUpdater');
}
